import Icon from '../components/Icon.vue';
Icon.register({
  bed: {
    width: 640,
    height: 512,
    paths: [{
      d: 'M176 256c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zM528 128c61.9 0 112 50.1 112 112v192c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48h-512v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-352c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v208h224v-144c0-8.8 7.2-16 16-16h224z'
    }]
  }
});